<div class="main-screen-container">
    <div class="top-row">
        <div fxLayoutAlign="center center"
            style="display:flex;gap:20px;align-items:center;margin-bottom:10px;padding-top:20px;">

            <button mat-flat-button class="btn-action btn-with-icon" color="accent"
                (click)="router.navigate(['rekbots-list'])"><img style="width:25px;" src="/assets/img/back.png"
                    alt="">Powrót</button>
        </div>
    </div>
    <mat-card class="list-container">
        <mat-card-content>
            <div class="row">
                <div class="col-12">
                    <h3>Dodaj rekbota</h3>
                    <app-rekbot-form [rekbotId]="0"></app-rekbot-form>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <div style="height:50px">

    </div>
</div>